import React, { createContext, useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import { filterProviderFactory } from '../../../../../../../../../../../utils/filterProviderFactory';
import { useQueryString } from '../../../../../../../../../../../utils/hooks';

const { Provider, useFilters } = filterProviderFactory();
/**
 * Conversion filters
 */
export const InfluencerFiltersProvider = ({ children }) => {
	/**
	 * @param {InfluencerFilters.State} controlValues
	 */
	const mapControlsToState = (controlVals) => {
		const {
			invitesClickCountSwitch,
			invitesSwitch,
			revenueSwitch,
			conversionsSwitch,
			fromDate,
			toDate,
			...state
		} = controlVals;

		return {
			...state,
			createdDateGTOE: fromDate,
			createdDateLTOE: toDate,
		};
	};

	return (
		<Provider mapControlsToState={mapControlsToState}>{children}</Provider>
	);
};

export const useInfluencerFilters = useFilters;
